import { CollectionForm } from '../../../../models/ts/collection-form.model';
import { EntityState } from '@ngrx/entity';
import { CollectionFormValidatorResult } from '../../../features/bizzmine/form/classes/collection-form-validator-result';
import { StoreCollectionFormOptions } from './interfaces/store-collection-form-options';
import { SchedulerDto } from 'src/models/ts/scheduler-dto.model';
import { SkillIntegrityCheck } from '../../../../models/ts/skill-integrity-check.model';

export type FormsState = EntityState<StoreCollectionForm>;

export class StoreCollectionForm {
  public id: string;
  public status: StoreCollectionFormStatus;
  public validationResult?: CollectionFormValidatorResult;
  public loading?: boolean;
  public reset?: boolean;
  public integrity?: Array<{ fieldId: number, value: SkillIntegrityCheck }>;
  public hasUnconfirmedAiContent?: boolean = false;
  public aiAllAccepted?: boolean = false;
  public hasAiUnsavedChanges?: boolean = false;

  public constructor(public data: CollectionForm,
                     public options?: Partial<StoreCollectionFormOptions>,
                     public schedulerData?: SchedulerDto
  ) {
    this.id = crypto.randomUUID();
    this.status = initialStoreCollectionFormStatus;
  }
}


export function storeFormIsIdle(form: StoreCollectionForm): boolean {
  if (form.status === undefined) {
    return true;
  } else return form.status.api === StoreCollectionFormApiStatus.Idle &&
    form.status.formula === StoreCollectionFormFormulaStatus.Idle &&
    form.status.initialization === StoreCollectionFormInitializationStatus.Initialized &&
    form.status.lookup === StoreCollectionFormLookupStatus.Idle &&
    form.status.scripting === StoreCollectionFormScriptingStatus.Idle;
}

export interface StoreCollectionFormStatus {
  initialization: StoreCollectionFormInitializationStatus;
  scripting: StoreCollectionFormScriptingStatus;
  formula: StoreCollectionFormFormulaStatus;
  api: StoreCollectionFormApiStatus;
  lookup: StoreCollectionFormLookupStatus;
}

export enum StoreCollectionFormInitializationStatus {
  Initializing,
  Initialized
}

export enum StoreCollectionFormLookupStatus {
  Idle,
  InitializingLookup,
  FetchingLookupData,
  ProcessingLookupData,
  UpdatingViewDataSources,
  UpdatingFields,
  Complete
}

export enum StoreCollectionFormApiStatus {
  Idle,
  BuildingRequest,
  FetchingResponse,
  ResponseFetched
}

export enum StoreCollectionFormFormulaStatus {
  Idle,
  Calculating,
  UpdatingOutput,
  Complete
}

export enum StoreCollectionFormScriptingStatus {
  Idle,
  Evaluating,
  ExecutingActions
}

export const initialStoreCollectionFormStatus: StoreCollectionFormStatus = {
  initialization: StoreCollectionFormInitializationStatus.Initializing,
  formula: StoreCollectionFormFormulaStatus.Idle,
  api: StoreCollectionFormApiStatus.Idle,
  lookup: StoreCollectionFormLookupStatus.Idle,
  scripting: StoreCollectionFormScriptingStatus.Idle
};